module.exports = __webpack_public_path__ + "img/04.7e45c6f9.png";